export const GET_ALL_MUSEUMS = "GET_ALL_MUSEUMS";
export const GET_ALL_MUSEUMS_FAIL = "GET_ALL_MUSEUMS_FAIL";
export const GET_ALL_MUSEUMS_SUCCESS = "GET_ALL_MUSEUMS_SUCCESS";

export const GET_MUSEUM = "GET_MUSEUM";
export const GET_MUSEUM_FAIL = "GET_MUSEUM_FAIL";
export const GET_MUSEUM_SUCCESS = "GET_MUSEUM_SUCCESS";


export const GET_TOP_MUSEUM = "GET_TOP_MUSEUM";
export const GET_TOP_MUSEUM_FAIL = "GET_TOP_MUSEUM_FAIL";
export const GET_TOP_MUSEUM_SUCCESS = "GET_TOP_MUSEUM_SUCCESS";

export const GET_TOP_ARTISTS = "GET_TOP_ARTISTS";
export const GET_TOP_ARTISTS_FAIL = "GET_TOP_ARTISTS_FAIL";
export const GET_TOP_ARTISTS_SUCCESS = "GET_TOP_ARTISTS_SUCCESS";


export const GET_ALL_ARTISTS = "GET_ALL_ARTISTS";
export const GET_ALL_ARTISTS_FAIL = "GET_ALL_ARTISTS_FAIL";
export const GET_ALL_ARTISTS_SUCCESS = "GET_ALL_ARTISTS_SUCCESS";